import "./PageSelector.css";

import { Dispatch, SetStateAction } from "react";

import { ChevronRightIcon } from "../../../../../../../../../assets";
import { Button } from "../../../../../../../../../widget";

interface PageSelectorProps {
  showPermissionsPage: boolean;
  setShowPermissionsPage: Dispatch<SetStateAction<boolean>>;
  handleSubmitProjectPhaseDates: () => void;
}
export const PageSelector = ({
  showPermissionsPage,
  setShowPermissionsPage,
  handleSubmitProjectPhaseDates,
}: PageSelectorProps): JSX.Element => {
  return (
    <div className="PageSelector">
      {showPermissionsPage ? (
        <Button
          text="Project selection"
          variant="reversedPrimary"
          textUnderline
          fontWeight="light"
          size="small"
          hasNoPadding
          onClick={() => setShowPermissionsPage(false)}
        />
      ) : (
        <p className="body2">
          <b>Project selection</b>
        </p>
      )}
      <ChevronRightIcon />
      {!showPermissionsPage ? (
        <Button
          text="Permissions"
          variant="reversedPrimary"
          textUnderline
          fontWeight="light"
          size="small"
          hasNoPadding
          onClick={handleSubmitProjectPhaseDates}
        />
      ) : (
        <p className="body2">
          <b>Permissions</b>
        </p>
      )}
    </div>
  );
};
